<template>
    <div class="parking-pan-zoom">
        <div class="parking-pan-zoom__zoom">
            <div :class="['parking-pan-zoom__zoom-btn', {'is-disabled': zoom.max.disabled}]" @click="zoomPlus">
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 7L7 7M1 7L7 7M7 7L7 1M7 7L7 13.5" stroke="#0B1739" stroke-width="2" stroke-linecap="round"/></svg>
            </div>

            <div :class="['parking-pan-zoom__zoom-btn', {'is-disabled': zoom.min.disabled}]" @click="zoomMinus">
                <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L7 1L1 1" stroke="#0B1739" stroke-width="2" stroke-linecap="round"/></svg>
            </div>
        </div>

        <SvgPanZoom
            style="width: 100%; height: 100%;"
            :zoomEnabled="true"
            :mouseWheelZoomEnabled="false"
            :dblClickZoomEnabled="false"
            :fit="false"
            :center="true"
            :minZoom="options ? options.minZoom : zoom.min.val"
            :maxZoom="options ? options.maxZoom : zoom.max.val"
            :customEventsHandler="customEventsHandler"
            @svgpanzoom="registerSvgPanZoom"
        >
            <svg style="width: 100%; height: 100%;">
                <g>
                    <slot></slot>
                </g>
            </svg>
        </SvgPanZoom>
    </div>
</template>

<style lang='scss'>
    @import "./PanZoom.scss";
</style>

<script>
import Hammer from 'hammerjs';
import SvgPanZoom from 'vue-svg-pan-zoom';

export default {
    props: ['options'],

    components: {
        SvgPanZoom
    },

    data: () => {
        return {
            svgpanzoom: null,
            zoom      : {
                min: {
                    val     : 0.85,
                    disabled: false
                },
                max: {
                    val     : 4,
                    disabled: false
                }
            }
        };
    },

    computed: {
        customEventsHandler() {
            return {
                haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                init              : this.initCustomEventsHandler.bind(this),
                destroy           : () => {
                    if (this.hammerPinch) {
                        this.hammerPinch.destroy();
                    }

                    this.$emit('afterDestroy');
                }
            };
        }
    },

    methods: {
        registerSvgPanZoom(svgpanzoom) {
            this.svgpanzoom = svgpanzoom;

            if (this.options && this.options.minZoom) {
                this.zoom.min.val = this.options.minZoom;
            }

            if (this.options && this.options.maxZoom) {
                this.zoom.max.val = this.options.maxZoom;
            }

            if (this.options && this.options.setMinZoom) {
                svgpanzoom.zoom(this.zoom.min.val);

                this.checkMaxMinZoom();
            }

            // this.$emit('registerSvgPanZoom', svgpanzoom);
        },

        /* Для пинча в мобилках */
        initCustomEventsHandler(options) {
            const instance = options.instance;
            let initialScale = 1;
            let pannedX = 0;
            let pannedY = 0;

            this.hammerPinch = new Hammer(options.svgElement);
            this.hammerPinch.get('pinch').set({enable: true});

            if (this.options.dblClickZoomEnabled) {
                this.hammerPinch.on('doubletap', () => {
                    instance.zoomIn();
                });
            }

            this.hammerPinch.on('panstart panmove', (event) => {
                if (event.type === 'panstart') {
                    pannedX = 0;
                    pannedY = 0;
                }

                instance.panBy({
                    x: event.deltaX - pannedX,
                    y: event.deltaY - pannedY
                });

                pannedX = event.deltaX;
                pannedY = event.deltaY;
            });

            this.hammerPinch.on('pinchstart pinchmove', (event) => {
                if (event.type === 'pinchstart') {
                    initialScale = instance.getZoom();
                    instance.zoomAtPoint(initialScale * event.scale, {
                        x: event.center.x,
                        y: event.center.y
                    });
                }

                instance.zoomAtPoint(initialScale * event.scale, {
                    x: event.center.x,
                    y: event.center.y
                });

                this.checkMaxMinZoom();
            });

            options.svgElement.addEventListener('touchmove', (event) => {
                event.preventDefault();
            });

            this.$emit('initCustomEvents');
        },

        zoomPlus() {
            if (!this.svgpanzoom) {
                return;
            }

            this.svgpanzoom.zoomIn();
            this.checkMaxMinZoom();
        },

        zoomMinus() {
            if (!this.svgpanzoom) {
                return;
            }

            this.svgpanzoom.zoomOut();
            this.checkMaxMinZoom();
        },

        checkMaxMinZoom() {
            if (!this.svgpanzoom) {
                return;
            }

            const zoom = this.svgpanzoom.getZoom().toFixed(2);

            this.zoom.min.disabled = zoom <= this.zoom.min.val;
            this.zoom.max.disabled = zoom >= this.zoom.max.val;

            if (this.zoom.min.disabled) {
                this.svgpanzoom.center();
            }
        }
    }
};
</script>

